import {utf8Query} from "../consts/globals";

export const defaultConfig = {
  // [PC개편] 컬렉션 ID 추가.
  imageCollId: "imgColl",
  wrapCollId: "imgWrapColl", // 전체 width 체크용 wrap id
  bodyListId: "imgList", // 이미지들을 append할 list의 body id
  expandButtonId: "imgExtendView", // 더보기 버튼 id

  isTab: (window.param_w === 'img'), // param_w가 img면 true, 아니면 false
  isMobile: false, // mobile 여부

  // 새로추가된 라인컷팅 6번 로직용 body의 over 허용량 계산시 사용되는 %률, 초기 60%로 잡았다.
  // 이후 디바이스별로 조정 할수도 있고, pc/mo 를 분리할 경우도 생길것 같다.
  boardOverflowLimit: 0.5,

  // zoom crop의 배율 10% -> 0.1
  cropMagnification: 0.2,

  // 통검일때만 사용하는 옵션
  // 패턴 키워드일때 컬렉션 기본 노출 line 조정 (2->3)
  showLineCount: 2,

  // 고정된 DIV 사이즈를 가져야 하는 fixed 이미지들의 div 고정 값 (PC tab 기본값, 그외는 하단에서 override)
  // PC Tab (W:77 / H:162), 그외 pc tot, mo (W:68 / H:90)
  fixedImageDivWidth: 77,
  fixedImageDivHeight: 162,

  minImageDivHeight: 9999,
  maxImageDivHeight: 0,

  useImageType: "0x200_85_hr", // PC Tab 기본값, data에서 사용될 썸네일 사이즈 type 값.
  useThumbPx: 200, // 썸네일의 기본 수치값을 사용한 사이즈 (170 이면 170수치값 mo_width, mo_height를 사용)
  bodyLimitWidth: 832, // PC tab 기본값, window의 최소 resize width 값, 해당 값 이하로 width가 더 줄어들지 않는다.
  imageDivMargin: 3, // PC tab 기본값, 이미지의 div 기본 여백 margin 값. (비율 계산시에도 사용됨)

  defaultMoreBtnClassName: "coll_extend extend_type5 extend_imgtab", // PC Tab 기본값. 펼쳐보기의 className

  userReportMode: false, // PC 통검 전용. 신고하기 동작이 달라서 값을 따로 뺌.
  freeLogStr: "https:" + window.SEARCHLOGDOMAIN + "/fr/imgviewer/p?vle=",
  dataIsEndByFirstPage: false, // 첫 페이지 데이터가 isEnd 인지 표시하는 flag
  imageViewerLink: "?w=imgviewer&q=AOA%20%EC%82%AC%EC%A7%84", //mo 전용, 뷰어로 이동하기 위한 기본 link param
  utf8Query, // 쿼리 utf8
  addLinkParam: "", //링크에 추가되는 param option
  addQsearchParam: "", // ajax request 시 추가되는 param option

  // 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
  basicCode: {
    "s": "IM",
    "a": "IMTO",
    "dc": "IIM"
  }
};

export const defaultState = {

  // pc 통검용 펼쳐보기 UI -> 접기 강제 전환 flag
  // 마지막 펼쳐보기 시에는 접기 UI가 변경 되어야 한다. (펼쳐보기+접기 X, 접기만 O)
  flagMoreUiBtnReset: false,

  // PC통검 전용,
  // 접기가 한번 노출 된 이후,
  // 즉. ajax response로 인해 누적된 데이터가 이 후 펼쳐보기 시도에서 충분하다 판단할 수 있게 하는 flag,
  // true인 경우 펼쳐보기시 데이터 추가로드를 하지 않는다.
  flagNoMoreAjaxRequestToBtn: false,

  // ajax request 제어 flag, true면 데이터를 추가로 호출하지 않음.
  flagAjaxRequestLock: false,

  indexImageInDoc: 0, // 뷰어 open 후 문서내 이미지 api 호출한 indexImageInViewer 값. async라 연속적인 viewer open 시 response time으로 인해 sync가 틀어지는 것을 체크. 값이 다르면 load 하지 않음.
  stepScrollSize: 0, //PC전용, viewer open 시 window의 scroll 값을 저장하고 있다.

  lineCountOfTotalRenderImage: 0, // 화면에 render한 현상태의 총 line count, window가 resize되면 이 값도 변한다.

};


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/default_settings.js
 **/